import React, { useState, useEffect } from 'react';

export default function AsyncComponent({ importComponent, handleNotificationUpdate }) {
  const [component, setComponent] = useState(null);

  useEffect(() => {
    const loadComponent = async () => {
      try {
        const { default: Component } = await importComponent();
        setComponent(<Component handleNotificationUpdate={handleNotificationUpdate} />);
      } catch (error) {
        console.error('Error while loading component:', error);
      }
    };

    loadComponent();
  }, [importComponent, handleNotificationUpdate]);

  return component;
}